export default {
  styleOverrides: {
    root: {
      position: 'absolute',
      bottom: '-17px',
    },
  },
};
